import * as React from "react";

import { formatStatus } from "../lib/format";
import { LinkedinCampaignStatus } from "../types/linkedin";
import { StatusPill } from "./status-pill";

export function LinkedinCampaignStatusPill({
  status,
}: {
  status: LinkedinCampaignStatus;
}) {
  switch (status) {
    case LinkedinCampaignStatus.ACTIVE:
      return <StatusPill tone="green">Active</StatusPill>;
    case LinkedinCampaignStatus.PAUSED:
      return <StatusPill tone="amber">Paused</StatusPill>;
    default:
      return <StatusPill tone="gray">{formatStatus(status)}</StatusPill>;
  }
}
